<template>
  <div :class="['mb-4 flex', message.type === 'user' ? 'justify-end' : 'justify-start']">
    <!-- Mensaje Normal o Mensaje de Error -->
    <div :class="[
      'px-4 py-3 rounded-xl shadow-md max-w-3/4', 
      message.type === 'user' 
        ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-tr-none'
        : message.isError
          ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-tl-none border border-yellow-300'
          : 'bg-white border border-blue-100 rounded-tl-none'
    ]">
      <!-- Icono de alerta para mensajes de error -->
      <div v-if="message.isError" class="flex items-center mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-yellow-300 mr-2 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span class="font-medium text-white">Problema de conexión</span>
      </div>
      
      <!-- Contenido del mensaje -->
      <div class="message-text" :class="{
        'text-white': message.type === 'user' || message.isError, 
        'text-gray-800': message.type !== 'user' && !message.isError
      }">
        <VueMarkdown :source="message.text" />
      </div>
      
      <!-- Marca de tiempo -->
      <div class="flex justify-end mt-1">
        <span :class="[
          'text-xs italic', 
          message.type === 'user' ? 'text-blue-100' : message.isError ? 'text-yellow-200' : 'text-gray-500'
        ]">
          {{ formatTime(message.timestamp) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue3-markdown-it';

export default {
  components: {
    VueMarkdown
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.max-w-3\/4 {
  max-width: 75%;
}

.message-text :deep(p) {
  margin-bottom: 0.5rem;
}

.message-text :deep(p:last-child) {
  margin-bottom: 0;
}

.message-text :deep(code) {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.1rem 0.3rem;
  border-radius: 0.2rem;
  font-size: 0.9em;
}

.message-text.text-white :deep(code) {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.message-text :deep(pre) {
  padding: 0.75rem;
  border-radius: 0.5rem;
  overflow-x: auto;
  margin: 0.5rem 0;
  background-color: rgba(0, 0, 0, 0.05);
}

.message-text.text-white :deep(pre) {
  background-color: rgba(255, 255, 255, 0.1);
}

.animate-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
</style>